import axios from 'axios'
import router from '@/router'
import {
  Toast
} from 'vant'
import {
  Dialog
} from 'vant';

// import store from '../store'
// import { getToken } from '@/utils/auth'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api的base_url
  timeout: 15000 // 请求超时时间
})
let tptypes = false
// request拦截器
service.interceptors.request.use(config => {
  // console.log(config.type)
  if (config.tptype) {
    tptypes = true
  } else {
    tptypes = false
  }

  config.headers['clientCode'] = 'wxGH'
  if (sessionStorage.getItem('userinfo')) {
    let token = JSON.parse(sessionStorage.getItem('userinfo')).jwtToken
    config.headers['AizhidaoAuthorizationTokenKey'] = token
  } else {
    config.headers['AizhidaoAuthorizationTokenKey'] = ''
  }
  if (process.env.NODE_ENV == 'development') {
    if (config.type == 1) {
      config.baseURL = 'https://dev.aimanrenjian.net:8443/crm-v1/manager/api'
    } else {
      // https://web.aimanrenjian.net/qjzx/api
      config.baseURL = process.env.VUE_APP_API_BASE_URL
      // config.baseURL = 'https://web.aimanrenjian.net/qjzx/api'
    }
  } else {
    config.baseURL = process.env.VUE_APP_API_BASE_URL
  }
  if (config.isloading) {}
  return config
}, error => {
  console.log(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status < 0) {
      console.log(tptypes)
      if (!tptypes) {
        Toast.fail(res.message);
      }
      // if()
      console.log(res.message)
      return Promise.reject(res.message)
    } else if (res.status == 1) {
      // Toast(res.message);
      // sessionStorage.removeItem('token')
      sessionStorage.removeItem('userinfo')
      console.log(router.currentRoute.value)
      console.log(router.currentRoute.value.fullPath)
      Dialog.alert({
        title: '提示',
        message: '用户身份已过期，请重新登录',
      }).then(() => {
        router.push({
          path: '/login',
          query: {
            redirect: router.currentRoute.value.fullPath // router对象自带的属性
          }
        })
      });
      return Promise.reject(res.message)
    } else {
      return response.data
      // Promise.resolve(response.data)
    }
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "请求错误(400)";
          break;
        case 401:
          console.log("登录");
          // return history.push('/login')
          break;
        case 403:
          err.message = "拒绝访问(403)";
          break;
        case 404:
          err.message = "请求出错(404)";
          break;
        case 408:
          err.message = "请求超时(408)";
          break;
        case 500:
          err.message = "服务器错误(500)";
          break;
        case 501:
          err.message = "服务未实现(501)";
          break;
        case 502:
          err.message = "网络错误(502)";
          break;
        case 503:
          err.message = "服务不可用(503)";
          break;
        case 504:
          err.message = "网络超时(504)";
          break;
        case 505:
          err.message = "HTTP版本不受支持(505)";
          break;
        default:
          err.message = `连接出错(${err.response.status})!`;
      }
    } else {
      err.message = "连接服务器失败!";
    }
    // ElMessage({
    //   showClose: true,
    //   message: err.message,
    //   type: 'error',
    //   duration: 0
    // });
    // ElMessage.error(JSON.stringify(error));
    return Promise.reject(res.message)
  }
)
export default service